import React from 'react'
import ReactDOM from 'react-dom'

const ModalOverlay = ({ isShowing, onClick }) =>
  isShowing
    ? ReactDOM.createPortal(
        <div
          role="none"
          onClick={onClick}
          className="fixed inset-0 bg-black-25 z-20 cursor-pointer"
        ></div>,
        document.body
      )
    : null

export default ModalOverlay
